import BrandButton from './BrandButton';

export default BrandButton;


// WEBPACK FOOTER //
// ./src/components/BrandButton/index.js